//
// Class representing an auction
function AdsNinjaAuction(id){

    // Constants.
    this.TIME_TO_LIVE_BUFFER                        = 10;                     // Abbreviated TTL.
    this.INDEX_VALNET_USED                          = 'valnetUsed';
    this.INDEX_VALNET_EXPIRED                       = 'valnetExpired';
    this.INDEX_VALNET_INVALIDATED                   = 'valnetInvalidated';
    this.INDEX_VALNET_BLACKLISTED                   = 'valnetBlacklisted';
    this.INDEX_VALNET_SENT_CURRENTLY                = 'valnetSentCurrently';
    this.INDEX_VALNET_SENT_NUMBER_OF_TIMES          = 'valnetSentNumberOfTimes';
    this.INDEX_VALNET_FROM_AUCTION                  = 'valnetFromAuction';
    this.INDEX_VALNET_BELONG_TO_LAST_AUCTION        = 'valnetBelongToLastAuction';
    this.BIDDING_LIBRARY_AMAZON                     = 'amazon';
    this.BIDDING_LIBRARY_PREBID                     = 'prebid';

    this.BIDDING_LIBRARIES                          = [ // TODO: Check.
        this.BIDDING_LIBRARY_AMAZON,
        this.BIDDING_LIBRARY_PREBID,
    ];

    this.TRACKED_DEALS                              = [
        "2212428",
        "2265248",
        "2265251",
        "2268396",
        "2268398",
        "2269878",
        "2269892",
        "opath-326-1629-fl7pq0ut2p",
        "opath-326-1629-sfg40magm7",
        "opath-326-2158-clgtkb8u6t",
        "opath-326-2158-zp9kpu1e3",
        "opath-326-2965-kfjva6xg8b",
        "opath-326-2965-9z4b1b1xbb",
        "opath-326-2965-yof0qxyc5n",
        "IX773418041159881499",
        "3846737",
    ];

    this.__id                                = id;
    this.__auctionType                       = 'initial'; // TODO: Use when differentiating with refresh.
    this.__isAdServerRequestSent             = false;
    this.__areBidsRequested                  = false;
    this.__areAmazonBidsBack                 = false;
    this.__arePrebidBidsBack                 = false;
    this.__amazonTimeout                     = 2000;
    this.__prebidTimeout                     = 2000;
    this.__adServerRequestFailsafeTimeout    = null;
    this.__isPageLoad                        = null;
    this.__consentNeeded                     = null;
    this.__gamAdSlots                        = []; // TODO: Refactor for ease of use allowing storing as object but retrieving as array.
    this.__ads                               = {};
    this.__prebidAdUnitBidderConfigs         = [];
    this.__amazonAdSlots                     = [];
    this.__prebidAdUnits                     = [];
    this.__shouldDelaySendingAdServerRequest = false;
    this.__bidPoolPrebid                     = {}; // TODO: Use this for video bids.
    this.__bidPoolAmazon                     = {};
    this.__completionCallbacks               = {};
    this.__logger                            = null;
    this.__noNewBidsPrebid                   = false;
    this.__noNewBidsAmazon                   = false;
    this.__videoPlacement                    = null;
    this.__logData                           = new AdsNinjaLogData();
    this.__brand                             = null;
    this.__noBiddingAuction                  = false;
    this.__inflateBidPool                    = false;
    this.__amazonBidders                     = {};
    this.__prebidBidders                     = {};
    this.__gamBidders                        = {};
    this.__newBidsDictionary                 = {
        prebid: {},
        amazon: {},
    };

    // this.__logData.setProperty('auctionId', id);
    this.__logData.setHiddenProperty('auctionStart', Date.now());
}

AdsNinjaAuction.prototype.getId = function(){

    return this.__id;
};

AdsNinjaAuction.prototype.isAdServerRequestSent = function(){

    return this.__isAdServerRequestSent;
};

AdsNinjaAuction.prototype.setIsAdServerRequestSent = function(isAdServerRequestSent){

    this.__isAdServerRequestSent = isAdServerRequestSent;
    var now                      = Date.now();

    this.__logData.setHiddenProperty('adServerRequestSentTime', now);
    this.__logData.setTimeProperty(`4. GAM Request Sent`, now, 'auctionStart');
};

AdsNinjaAuction.prototype.areBidsRequested = function(){

    return this.__areBidsRequested;
};

AdsNinjaAuction.prototype.setAreBidsRequested = function(areBidsRequested){

    this.__areBidsRequested = areBidsRequested;
    var now                 = Date.now();

    this.__logData.setHiddenProperty('bidsRequestedTime', now);
    this.__logData.setTimeProperty(`1. Prebid and Amazon Bids Requested`, now, 'auctionStart');
};

AdsNinjaAuction.prototype.areAmazonBidsBack = function(){

    return this.__areAmazonBidsBack;
};

AdsNinjaAuction.prototype.setAreAmazonBidsBack = function(areAmazonBidsBack){

    this.__areAmazonBidsBack = areAmazonBidsBack;
    var now                  = Date.now();

    // this.__logData.setProperty('amazonBidsBack', true);
    this.__logData.setHiddenProperty('amazonBidsBackTime', now);
    this.__logData.setTimeProperty(`2. Amazon Bids Back`, now, 'auctionStart');

};

AdsNinjaAuction.prototype.arePrebidBidsBack = function(){

    return this.__arePrebidBidsBack;
};

AdsNinjaAuction.prototype.setArePrebidBidsBack = function(arePrebidBidsBack){

    this.__arePrebidBidsBack = arePrebidBidsBack;
    var now                  = Date.now();

    // this.__logData.setProperty('prebidBidsBack', true);
    this.__logData.setHiddenProperty('prebidBidsBackTime', now);
    this.__logData.setTimeProperty(`3. Prebid Bids Back`, now, 'auctionStart');
};

//
// Returns true if all bids are back.
AdsNinjaAuction.prototype.areAllBidsBack = function(){

    return this.areAmazonBidsBack() && this.arePrebidBidsBack();
};

AdsNinjaAuction.prototype.getAmazonTimeout = function(){

    return this.__amazonTimeout;
};

AdsNinjaAuction.prototype.setAmazonTimeout = function(amazonTimeout){

    this.__amazonTimeout = amazonTimeout;
};

AdsNinjaAuction.prototype.getPrebidTimeout = function(){

    return this.__prebidTimeout;
};

AdsNinjaAuction.prototype.setPrebidTimeout = function(prebidTimeout){

    this.__prebidTimeout = prebidTimeout;
};

AdsNinjaAuction.prototype.setBrand = function(brand){

    this.__brand = brand;
}

//
// Returns ad server request failsafe timeout in milliseconds.
AdsNinjaAuction.prototype.getAdServerRequestFailsafeTimeout = function(){

    return this.__adServerRequestFailsafeTimeout;
}

//
// Sets ad server request failsafe timeout in milliseconds.
AdsNinjaAuction.prototype.setAdServerRequestFailsafeTimeout = function(adServerRequestFailsafeTimeout){

    this.__adServerRequestFailsafeTimeout = adServerRequestFailsafeTimeout;
}

AdsNinjaAuction.prototype.isPageLoad = function(){

    return this.__isPageLoad;
};

AdsNinjaAuction.prototype.setIsPageLoad = function(isPageLoad){

    this.__isPageLoad = isPageLoad;
};

AdsNinjaAuction.prototype.getConsentNeeded = function(){

    return this.__consentNeeded;
};

AdsNinjaAuction.prototype.setconsentNeeded = function(consentNeeded){

    this.__consentNeeded = consentNeeded;
};

//
// Returns ad slots.
AdsNinjaAuction.prototype.getGamAdSlots = function(){

    return this.__gamAdSlots;
};

//
// Sets ad slots and stores them as array and object.
AdsNinjaAuction.prototype.setGamAdSlots = function(gamAdSlots){

    if(!Array.isArray(gamAdSlots)){

        throw new Error(`Provided value of parameter "gamAdSlots" is not an array.`);
    }

    this.__gamAdSlots = gamAdSlots;

    for(var x in this.__gamAdSlots){

        if(this.__gamAdSlots[x] && typeof this.__gamAdSlots[x] === 'object' && this.__gamAdSlots[x].hasOwnProperty('adElementId')){

            this.__ads[this.__gamAdSlots[x]['adElementId']] = this.__gamAdSlots[x];
            this.__gamAdSlots[x].setAuctionId(this.__id);
            this.__gamAdSlots[x].setTid();
        }
    }
};

//
// Returns an ad found by adElementId, throws exception if not found.
AdsNinjaAuction.prototype.getAd = function(adElementId){

    var result = this.__ads[adElementId];

    if(!result){

        throw new Error(`Unable to find ad from adElementId: ${adElementId}.`, {
            ads: this.__ads,
        });
    }

    return result;
};

// AdsNinjaAuction.prototype.getGamAdSlotInstances = function(){
//
//     var result = [];
//
//     for(x in this.__gamAdSlots){
//
//         result.push(window[this.__gamAdSlots[x]['slotReferenceVariableName']]);
//     }
//
//     return result;
// };

//
// Returns div IDs for ads in this auction.
AdsNinjaAuction.prototype.getDivIdsOnlyBanner = function(){

    var result = [];

    for(var x in this.__gamAdSlots){

        var slot = this.__gamAdSlots[x];

        // Don't include video div IDs.
        if(this.__gamAdSlots[x].usesVideoPlayerValstream()){

            continue;
        }

        result.push(slot['adElementId']);
    }

    return result;
}

//
// Returns div IDs for ads in this auction.
AdsNinjaAuction.prototype.getDivIdsOnlyVideo = function(){

    var result = [];

    for(var x in this.__gamAdSlots){

        var slot = this.__gamAdSlots[x];

        // Don't include non-video div IDs.
        if(!this.__gamAdSlots[x].usesVideoPlayerValstream()){

            continue;
        }

        result.push(slot['adElementId']);
    }

    return result;
}

AdsNinjaAuction.prototype.getPrebidAdUnitBidderConfigs = function(){

    return this.__prebidAdUnitBidderConfigs;
};

AdsNinjaAuction.prototype.setPrebidAdUnitBidderConfigs = function(prebidAdUnitBidderConfigs){

    this.__prebidAdUnitBidderConfigs = prebidAdUnitBidderConfigs;
};

AdsNinjaAuction.prototype.getAmazonAdSlots = function(){

    return this.__amazonAdSlots;
};

AdsNinjaAuction.prototype.addAmazonAdSlot = function(element){

    this.__amazonAdSlots.push(element);
};

AdsNinjaAuction.prototype.countAmazonAdSlots = function(){

    return this.__amazonAdSlots.length;
};

AdsNinjaAuction.prototype.isEmptyAmazonAdSlots = function(){

    return (this.__amazonAdSlots.length === 0);
};

AdsNinjaAuction.prototype.getPrebidAdUnits = function(){

    return this.__prebidAdUnits;
};

AdsNinjaAuction.prototype.setPrebidAdUnits = function(prebidAdUnits){

    this.__prebidAdUnits = prebidAdUnits;
};

//
// Returns a Prebid ad unit, throws an exception when not found.
AdsNinjaAuction.prototype.getPrebidAdUnit = function(adElementId){

    // TODO: Maybe refactor to speedup this lookup.
    for(var x in this.__prebidAdUnits){

        if(adElementId === this.__prebidAdUnits[x]['code']){

            return this.__prebidAdUnits[x];
        }
    }

    throw new Error(`Unable to find Prebid ad unit for adElementId: ${adElementId}.`);
};

AdsNinjaAuction.prototype.addPrebidAdUnit = function(element){

    this.__prebidAdUnits.push(element);
};

AdsNinjaAuction.prototype.countPrebidAdUnits = function(){

    return this.__prebidAdUnits.length;
};

AdsNinjaAuction.prototype.isEmptyPrebidAdUnits = function(){

    return (this.__prebidAdUnits.length === 0);
};

AdsNinjaAuction.prototype.getPrebidAdUnitCodes = function(){

    var result = [];

    for(x in this.__prebidAdUnits){

        result.push(this.__prebidAdUnits[x]['code']);
    }

    return result;
};

AdsNinjaAuction.prototype.getPrebidAdUnitCodesNonVideo = function(){

    var result = [];

    for(var x in this.__prebidAdUnits){

        if('object' === typeof this.__prebidAdUnits[x].mediaTypes && this.__prebidAdUnits[x].mediaTypes.hasOwnProperty('video') && this.__prebidAdUnits[x].mediaTypes.video.hasOwnProperty('valnetDedicatedPlayer') && this.__prebidAdUnits[x].mediaTypes.video.valnetDedicatedPlayer === true){

            continue;
        }

        result.push(this.__prebidAdUnits[x]['code']);
    }

    return result;
};

AdsNinjaAuction.prototype.getVideoPrebidAdUnit = function(){

    for(x in this.__prebidAdUnits){

        // TODO: Has instream video check so we don't have to check each time.
        if('object' === typeof this.__prebidAdUnits[x].mediaTypes && !this.__prebidAdUnits[x].mediaTypes.hasOwnProperty('banner') && !this.__prebidAdUnits[x].mediaTypes.hasOwnProperty('native') && this.__prebidAdUnits[x].mediaTypes.hasOwnProperty('video') && this.__prebidAdUnits[x].mediaTypes.video.hasOwnProperty('valnetDedicatedPlayer') && this.__prebidAdUnits[x].mediaTypes.video.valnetDedicatedPlayer === true){

            return this.__prebidAdUnits[x];
        }
    }

    return null;
};

//
// Returns a Prebid ad units, throws an exception when not found.
AdsNinjaAuction.prototype.getVideoPrebidAdUnits = function(){

    var result = [];

    for(x in this.__prebidAdUnits){

        // TODO: Has instream video check so we don't have to check each time.
        if('object' === typeof this.__prebidAdUnits[x].mediaTypes && !this.__prebidAdUnits[x].mediaTypes.hasOwnProperty('banner') && !this.__prebidAdUnits[x].mediaTypes.hasOwnProperty('native') && this.__prebidAdUnits[x].mediaTypes.hasOwnProperty('video') && this.__prebidAdUnits[x].mediaTypes.video.hasOwnProperty('valnetDedicatedPlayer') && this.__prebidAdUnits[x].mediaTypes.video.valnetDedicatedPlayer === true){

            result.push(this.__prebidAdUnits[x]);
        }
    }

    return result;
};

AdsNinjaAuction.prototype.getDisplayPrebidAdUnits = function(){

    var result = [];

    for(x in this.__prebidAdUnits){

        if('object' === typeof this.__prebidAdUnits[x].mediaTypes && !this.__prebidAdUnits[x].mediaTypes.hasOwnProperty('native') && (this.__prebidAdUnits[x].mediaTypes.hasOwnProperty('banner') || (this.__prebidAdUnits[x].mediaTypes.hasOwnProperty('video') && this.__prebidAdUnits[x].mediaTypes.video.hasOwnProperty('valnetDedicatedPlayer') && this.__prebidAdUnits[x].mediaTypes.video.valnetDedicatedPlayer !== true))){

            result.push(this.__prebidAdUnits[x]);
        }
    }

    return result;
};

AdsNinjaAuction.prototype.getVideoAmazonAdSlot = function(){

    // TODO: Fix. This only works for a video auction.
    for(var x in this.__amazonAdSlots){

        if(this.__amazonAdSlots[x].hasOwnProperty('mediaType') && 'video' === this.__amazonAdSlots[x]['mediaType']){

            return this.__amazonAdSlots[x];
        }
    }

    return null;
}

AdsNinjaAuction.prototype.isAmazonAvailable = function(){

    return (typeof window.apstag !== 'undefined' && !this.isEmptyAmazonAdSlots());
};

AdsNinjaAuction.prototype.isPrebidAvailable = function(){

    return (typeof window.pbjs !== 'undefined' && typeof window.pbjs.que !== 'undefined' && !this.isEmptyPrebidAdUnits());
};

AdsNinjaAuction.prototype.getShouldDelaySendingAdServerRequest = function(){

    return this.__shouldDelaySendingAdServerRequest;
};

AdsNinjaAuction.prototype.setShouldDelaySendingAdServerRequest = function(value){

    this.__shouldDelaySendingAdServerRequest = value;
};

//
// __logger
AdsNinjaAuction.prototype.setLogger = function(value){

    this.__logger = value;
};

//
// __completionCallbacks
AdsNinjaAuction.prototype.getCompletionCallback = function(adElementId){

    return this.__completionCallbacks[adElementId];
};
AdsNinjaAuction.prototype.setCompletionCallbackForVideo = function(callback){

    var divIds = this.getDivIdsOnlyVideo();

    for(var x in divIds){

        this.__completionCallbacks[divIds[x]] = callback;
    }
};

//
// Set Amazon bids.
AdsNinjaAuction.prototype.setBidsAmazon = function(bids, areReusedBids = false){

    if(!bids || bids.length === 0){

        return;
    }

    // Index bids by adElementId.
    var indexedBids = {};

    for(var x in bids){

        if(!indexedBids.hasOwnProperty(bids[x].slotID)){

            indexedBids[bids[x].slotID] = [];
        }

        indexedBids[bids[x].slotID].push(bids[x]);
    }

    this.__setBids(this.BIDDING_LIBRARY_AMAZON, indexedBids, areReusedBids);
};

//
// Set Prebid bids.
AdsNinjaAuction.prototype.setBidsPrebid = function(bids, areReusedBids = false){

    if((!bids || Object.keys(bids).length === 0)){

        return;
    }

    this.__setBids(this.BIDDING_LIBRARY_PREBID, bids, areReusedBids);
};

/**
 * Sets bids.
 * 
 * @param {string} biddingLibrary 
 * @param {Object} bids 
 * @param {boolean} areReusedBids 
 * @returns 
 */
AdsNinjaAuction.prototype.__setBids = function(biddingLibrary, bids, areReusedBids = false){

    if(false === this.BIDDING_LIBRARIES.indexOf(biddingLibrary)){

        this.__logger.error('Unknown bidding library.', {
            auctionId: this.__id,
            biddingLibrary: biddingLibrary,
        });

        return;
    }

    if(this.__newBidsDictionary && typeof this.__newBidsDictionary === 'object' && !this.__newBidsDictionary[biddingLibrary]){

        this.__newBidsDictionary[biddingLibrary] = {};
    }

    if((!bids || Object.keys(bids).length === 0)){

        return;
    }

    var bidPool = (this.BIDDING_LIBRARY_PREBID === biddingLibrary) ? this.__bidPoolPrebid : this.__bidPoolAmazon;

    // Combine and sort new bids with existing ones. Then add to
    for(var adElementId in bids){

        var bidsForSlot = bids[adElementId];

        if(bids[adElementId] && typeof bids[adElementId] === 'object' && bids[adElementId].hasOwnProperty('bids')){

            bidsForSlot = bids[adElementId].bids;
        }

        if(!bidsForSlot || !Array.isArray(bidsForSlot) || bidsForSlot.length === 0){

            continue;
        }

        if(!bidPool.hasOwnProperty(adElementId)){

            bidPool[adElementId] = [];
        }

        var invalidatedBidsCount = 0;

        if(!areReusedBids){

            // Add additional fields.
            for(var x in bidsForSlot){

                bidsForSlot[x][this.INDEX_VALNET_USED]                      = bidsForSlot[x][this.INDEX_VALNET_USED] || false;
                bidsForSlot[x][this.INDEX_VALNET_EXPIRED]                   = bidsForSlot[x][this.INDEX_VALNET_EXPIRED] || false;
                bidsForSlot[x][this.INDEX_VALNET_INVALIDATED]               = bidsForSlot[x][this.INDEX_VALNET_INVALIDATED] || false;
                bidsForSlot[x][this.INDEX_VALNET_BLACKLISTED]               = bidsForSlot[x][this.INDEX_VALNET_BLACKLISTED] || false;
                bidsForSlot[x][this.INDEX_VALNET_SENT_CURRENTLY]            = bidsForSlot[x][this.INDEX_VALNET_SENT_CURRENTLY] || false;
                bidsForSlot[x][this.INDEX_VALNET_SENT_NUMBER_OF_TIMES]      = bidsForSlot[x][this.INDEX_VALNET_SENT_NUMBER_OF_TIMES] || 0;
                bidsForSlot[x][this.INDEX_VALNET_FROM_AUCTION]              = bidsForSlot[x][this.INDEX_VALNET_FROM_AUCTION] || this.getId();
                bidsForSlot[x][this.INDEX_VALNET_BELONG_TO_LAST_AUCTION]    = bidsForSlot[x][this.INDEX_VALNET_BELONG_TO_LAST_AUCTION] || true;

                // Track PMPs
                if (bidsForSlot[x]["dealId"] && this.TRACKED_DEALS.includes(bidsForSlot[x]["dealId"])) {
                  bidsForSlot[x]["adserverTargeting"]["hb_deal_bidder"] = `${bidsForSlot[x]["adserverTargeting"]["hb_bidder"]}_${bidsForSlot[x]["dealId"]}`;
                  bidsForSlot[x]["adserverTargeting"]["hb_deal_flag"] = '1';
                }

                if(window.adsNinja.floorHelper 
                    && typeof window.adsNinja.floorHelper.isBidAboveLocalFloors === 'function'
                    && !bidsForSlot[x][this.INDEX_VALNET_INVALIDATED]
                    && !window.adsNinja.floorHelper.isBidAboveLocalFloors(biddingLibrary, bidsForSlot[x]) // TODO: Double check local floors.
                ){

                    invalidatedBidsCount                          += 1;
                    bidsForSlot[x][this.INDEX_VALNET_INVALIDATED] = true;
                }
            }

            this.__newBidsDictionary[biddingLibrary][adElementId] = true;

            if(invalidatedBidsCount === bidsForSlot.length){

                this.__logger.warn(`All bids invalidated for ${biddingLibrary}.`, {
                    auctionId: this.__id,
                    adElementId: adElementId,
                    invalidatedBidsCount: invalidatedBidsCount,
                });

                this.__newBidsDictionary[biddingLibrary][adElementId] = false;
            }
            else if(invalidatedBidsCount > 0){

                this.__logger.info(`Some bids invalidated for ${biddingLibrary}.`, {
                    auctionId: this.__id,
                    adElementId: adElementId,
                    invalidatedBidsCount: invalidatedBidsCount,
                });
            }
        }

        for(var y in bidPool[adElementId]){

            bidPool[adElementId][y][this.INDEX_VALNET_BELONG_TO_LAST_AUCTION] = false;
        }

        var combinedBids = bidPool[adElementId].concat(bidsForSlot);
        var sortedBids   = Object.values(combinedBids).sort(function(bidA, bidB){

            return Math.round(1000 * bidB.cpm) - Math.round(1000 * bidA.cpm);
        });

        bidPool[adElementId] = sortedBids;
    }
};

//
// Returns bids for slot.
AdsNinjaAuction.prototype.__getBidsForSlot = function(biddingLibrary, adElementId){

    if(false === this.BIDDING_LIBRARIES.indexOf(biddingLibrary)){

        this.__logger.error('Unknown bidding library.', {
            auctionId: this.__id,
            adElementId: adElementId,
            biddingLibrary: biddingLibrary,
        });

        return [];
    }

    if(this.BIDDING_LIBRARY_AMAZON === biddingLibrary){

        return this.__bidPoolAmazon[adElementId] || [];
    }

    return this.__bidPoolPrebid[adElementId] || [];
};

//
// Sets bids for slot.
AdsNinjaAuction.prototype.__setBidsForSlot = function(biddingLibrary, adElementId, bids){

    if(false === this.BIDDING_LIBRARIES.indexOf(biddingLibrary)){

        this.__logger.error('Unknown bidding library.', {
            auctionId: this.__id,
            adElementId: adElementId,
            biddingLibrary: biddingLibrary,
        });

        return;
    }

    if(this.BIDDING_LIBRARY_AMAZON === biddingLibrary){

        return this.__bidPoolAmazon[adElementId] = bids;
    }

    return this.__bidPoolPrebid[adElementId] = bids;
};

//
// Returns unused Prebid bids for slot.
AdsNinjaAuction.prototype.getUnusedBids = function(biddingLibrary){

    if(false === this.BIDDING_LIBRARIES.indexOf(biddingLibrary)){

        this.__logger.error('Unknown bidding library.', {
            auctionId: this.__id,
            biddingLibrary: biddingLibrary,
        });

        return [];
    }

    var bidPool = (this.BIDDING_LIBRARY_PREBID === biddingLibrary) ? this.__bidPoolPrebid : this.__bidPoolAmazon;
    var result  = (this.BIDDING_LIBRARY_PREBID === biddingLibrary) ? {} : [];

    for(var adElementId in bidPool){

        for(var bid in bidPool[adElementId]){

            var bidResult = this.__determineIfBidIsUsedOrExpired(bidPool[adElementId][bid]);

            bidPool[adElementId][bid] = this.__handleNewlyExpiredBid(biddingLibrary, adElementId, bidPool[adElementId][bid], bidResult);

            if(!bidResult.used && !bidResult.expired && !bidResult.invalidated && !bidResult.sentCurrently){

                bidPool[adElementId][bid][this.INDEX_VALNET_FROM_AUCTION] = bidPool[adElementId][bid][this.INDEX_VALNET_FROM_AUCTION] || this.getId();

                if (this.BIDDING_LIBRARY_PREBID === biddingLibrary) {
                  if(!result.hasOwnProperty(adElementId)){
                      result[adElementId] = [];
                  }

                  result[adElementId].push(bidPool[adElementId][bid]);
                } else {
                  result.push(bidPool[adElementId][bid]);
                }
            }
        }
    }

    this.__logger.debug(`Unused bids.`, {
        auctionId: this.__id,
        biddingLibrary: biddingLibrary,
        bids: result,
    });

    return result;
};

//
// Returns highest unused bids for slot.
AdsNinjaAuction.prototype.getHighestUnusedBid = function(biddingLibrary, adElementId, videoBidderBlacklist, onlyFromAuctionBidder = []){

    var bids = this.__getBidsForSlot(biddingLibrary, adElementId);

    this.__logger.debug('Ad slot bid pool.', {
        auctionId: this.__id,
        adElementId: adElementId,
        biddingLibrary: biddingLibrary,
        bidPool: bids,
    });
    var isFloatingPlayer = window.adsNinjaHeaderBiddingManager.isAdFloatingOrAlwaysFloating(adElementId);

    for(var x in bids){
        // Check the bid against the blacklist
        var bidder = bids[x].bidderCode || bids[x].targeting && bids[x].targeting.amzn;
        if (videoBidderBlacklist && videoBidderBlacklist.includes(bidder)) {
            bids[x][this.INDEX_VALNET_BLACKLISTED] = true;
        }

        var bidResult = this.__determineIfBidIsUsedOrExpired(bids[x]);

        var onlyFromAuctionCheckCleared = true;

        if(window.adsNinjaHeaderBiddingManager.getBrandName() === 'TheGamer'){
            //onlyFromAuctionCheckCleared = this.__bidPassedOnlyFromAuctionCheck(bids[x], onlyFromAuctionBidder);
        }

        if(!onlyFromAuctionCheckCleared){
               
            this.__logger.debug('TTD bid not passed only from auction check.', {
                bid: bids[x],
            });

        }


        if(!bidResult.used && !bidResult.expired && !bidResult.invalidated && !bidResult.sentCurrently && !bidResult.blacklisted && onlyFromAuctionCheckCleared){

            if(window.adsNinja.floorHelper 
                && typeof window.adsNinja.floorHelper.isBidAboveLocalFloors === 'function' 
                && !window.adsNinja.floorHelper.isBidAboveLocalFloors(biddingLibrary, bids[x])
            ){

                bids[x][this.INDEX_VALNET_INVALIDATED] = true;

                continue;
            }

            bids[x][this.INDEX_VALNET_SENT_CURRENTLY]       = true;
            bids[x][this.INDEX_VALNET_SENT_NUMBER_OF_TIMES] += 1;

            this.__logger.debug('Found highest bid.', {
                auctionId: this.__id,
                adElementId: adElementId,
                biddingLibrary: biddingLibrary,
                bid: bids[x],
            });

            this.__setBidsForSlot(biddingLibrary, adElementId, bids);

            return bids[x];
        }

        bids[x] = this.__handleNewlyExpiredBid(biddingLibrary, adElementId, bids[x], bidResult);
    }

    this.__setBidsForSlot(biddingLibrary, adElementId, bids);

    return null;
};

//
// Returns the multiple highest unused bids.
AdsNinjaAuction.prototype.getHighestUnusedBids = function(biddingLibrary, adElementId, bidCount, videoBidderBlacklist, onlyFromAuctionBidder = []){

    var bids     = this.__getBidsForSlot(biddingLibrary, adElementId);
    var highBids = [];

    for(var x in bids){

        // Check the bid against the blacklist
        var bidder = bids[x].bidderCode || bids[x].targeting && bids[x].targeting.amzn;

        if(videoBidderBlacklist && videoBidderBlacklist.includes(bidder)){

            bids[x][this.INDEX_VALNET_BLACKLISTED] = true;
        }

        var bidResult = this.__determineIfBidIsUsedOrExpired(bids[x]);

        var onlyFromAuctionCheckCleared = true;

        if(window.adsNinjaHeaderBiddingManager.getBrandName() === 'TheGamer'){
            //onlyFromAuctionCheckCleared = this.__bidPassedOnlyFromAuctionCheck(bids[x], onlyFromAuctionBidder);
        }

        if(!onlyFromAuctionCheckCleared){
            this.__logger.debug('TTD bid not passed only from auction check.', {
                bid: bids[x],
            });
        }

        if(!bidResult.used && !bidResult.expired && !bidResult.invalidated && !bidResult.sentCurrently && !bidResult.blacklisted && onlyFromAuctionCheckCleared){

            if(window.adsNinja.floorHelper 
                && typeof window.adsNinja.floorHelper.isBidAboveLocalFloors === 'function' 
                && !window.adsNinja.floorHelper.isBidAboveLocalFloors(biddingLibrary, bids[x])
            ){

                bids[x][this.INDEX_VALNET_INVALIDATED] = true;

                continue;
            }

            bids[x][this.INDEX_VALNET_SENT_CURRENTLY]       = true;
            bids[x][this.INDEX_VALNET_SENT_NUMBER_OF_TIMES] += 1;

            this.__logger.debug('Found highest bid.', {
                auctionId: this.__id,
                adElementId: adElementId,
                biddingLibrary: biddingLibrary,
                bid: bids[x],
            });

            this.__setBidsForSlot(biddingLibrary, adElementId, bids); // TODO: Why is this here?

            if((highBids.length < bidCount) && (bids[x].mediaType === 'video')){

              highBids.push(bids[x]);
            }
        }

        bids[x] = this.__handleNewlyExpiredBid(biddingLibrary, adElementId, bids[x], bidResult);
    }

    this.__setBidsForSlot(biddingLibrary, adElementId, bids);

    this.__logger.debug('Highest bids for VAST fallback: ', {
        adElementId,
        biddingLibrary,
        highBids,
    });

    return highBids;
};

//
// Marks highest bid for slot as used.
AdsNinjaAuction.prototype.markHighestBidAsUsed = function(biddingLibrary, adElementId, invalidate = false){

    var bids = this.__getBidsForSlot(biddingLibrary, adElementId);

    for(var x in bids){

        var bidResult = this.__determineIfBidIsUsedOrExpired(bids[x]);

        if(bidResult.sentCurrently && !bidResult.used && !bidResult.invalidated){

            bids[x][this.INDEX_VALNET_USED]           = true;
            bids[x][this.INDEX_VALNET_SENT_CURRENTLY] = false;

            if(invalidate){

                bids[x][this.INDEX_VALNET_INVALIDATED] = true;
            }

            if(this.BIDDING_LIBRARY_PREBID === biddingLibrary){

                if('TheGamer' === window.adsNinjaHeaderBiddingManager.getBrandName()){

                    window.adsNinjaHeaderBiddingManager.addAndConfirmBidUsed(adElementId, (bids[x].hasOwnProperty('adId')) ? bids[x].adId : 0);
                }

                this.__pbjsMarkWinningBidAsUsed(adElementId, bids[x]);
            }

            this.__setBidsForSlot(biddingLibrary, adElementId, bids);

            return bids[x];
        }

        bids[x] = this.__handleNewlyExpiredBid(biddingLibrary, adElementId,  bids[x], bidResult);
    }

    this.__setBidsForSlot(biddingLibrary, adElementId, bids);

    return false;
}

//
// Sets bid that was sent currently to the ad server to be reusable.
AdsNinjaAuction.prototype.allowBidsToBeReused = function(biddingLibrary, adElementId){

    var bids = this.__getBidsForSlot(biddingLibrary, adElementId);

    for(var x in bids){

        var bidResult = this.__determineIfBidIsUsedOrExpired(bids[x]);

        if(bidResult.sentCurrently && !bidResult.used && !bidResult.invalidated){

            bids[x][this.INDEX_VALNET_SENT_CURRENTLY] = false;
        }

        bids[x] = this.__handleNewlyExpiredBid(biddingLibrary, adElementId,  bids[x], bidResult);
    }

    this.__setBidsForSlot(biddingLibrary, adElementId, bids);
}

//
// Determines if bid is used or expired.
AdsNinjaAuction.prototype.__determineIfBidIsUsedOrExpired = function(bid){

    var ttlWithBuffer = (bid.ttl - this.TIME_TO_LIVE_BUFFER) * 1000;
    var expired       = (bid.responseTimestamp + ttlWithBuffer < Date.now());

    return {
        used: bid[this.INDEX_VALNET_USED],
        expired: expired,
        newlyExpired: (expired && !bid[this.INDEX_VALNET_EXPIRED]),
        invalidated: bid[this.INDEX_VALNET_INVALIDATED],
        sentCurrently: bid[this.INDEX_VALNET_SENT_CURRENTLY],
        blacklisted: bid[this.INDEX_VALNET_BLACKLISTED],
    };
}

//
// Determines if bid is used or expired.
AdsNinjaAuction.prototype.__invalidateBidPool = function(biddingLibrary, adElementId){

    var bids = this.__getBidsForSlot(biddingLibrary, adElementId);

    for(var x in bids){

        var bidResult = this.__determineIfBidIsUsedOrExpired(biddingLibrary, bids[x]);

        if(!bidResult.used && !bidResult.invalidated){

            bids[x][this.INDEX_VALNET_INVALIDATED] = true;

            if(this.BIDDING_LIBRARY_PREBID === biddingLibrary){

                this.__pbjsMarkWinningBidAsUsed(adElementId, bids[x]);
            }
        }

        bids[x] = this.__handleNewlyExpiredBid(biddingLibrary, adElementId,  bids[x], bidResult);
    }

    this.__setBidsForSlot(biddingLibrary, adElementId, bids);

    return true;
}

//
// Handles newly expired bids.
AdsNinjaAuction.prototype.__handleNewlyExpiredBid = function(biddingLibrary, adElementId, bid, bidResult){

    if(bidResult.newlyExpired){

        this.__logger.debug('Expired bid.', {
            auctionId: this.__id,
            adElementId: adElementId,
            biddingLibrary: biddingLibrary,
            bid: bid,
        });

        bid[this.INDEX_VALNET_EXPIRED] = true;
    }

    return bid;
}

//
// Need to also mark this for Prebid otherwise it could possibly get reused if these methods return not highest bid.
AdsNinjaAuction.prototype.__pbjsMarkWinningBidAsUsed = function(adElementId, bid){

    if(!window.pbjs || typeof window.pbjs.markWinningBidAsUsed !== 'function'){

        return;
    }

    var winningBidData = {
        adUnitCode: adElementId,
    };

    if(bid.hasOwnProperty('adId')){

        winningBidData['adId'] = bid.adId;
    }

    // TODO: Don't do this here?
    window.pbjs.markWinningBidAsUsed(winningBidData);
}

//
// Marks all highest bids as used.
AdsNinjaAuction.prototype.markAllHighestBidsAsUsed = function(adElementId){

    this.markHighestBidAsUsed(this.BIDDING_LIBRARY_PREBID, adElementId, true);
    this.markHighestBidAsUsed(this.BIDDING_LIBRARY_AMAZON, 'preroll', true);
}

//
// Invalidate the entire bid pool for an ad.
AdsNinjaAuction.prototype.invalidateBidPool = function(adElementId){

    this.__invalidateBidPool(this.BIDDING_LIBRARY_PREBID, adElementId);
    this.__invalidateBidPool(this.BIDDING_LIBRARY_AMAZON, 'preroll');
}

//
// Has new bids.
AdsNinjaAuction.prototype.hasNewBids = function(adElementId = null){

    for(var x in this.BIDDING_LIBRARIES){

        if(this.__newBidsDictionary 
            && typeof this.__newBidsDictionary === 'object' 
            && this.__newBidsDictionary[this.BIDDING_LIBRARIES[x]]
            && typeof this.__newBidsDictionary[this.BIDDING_LIBRARIES[x]] === 'object'
        ){

            if(adElementId && this.__newBidsDictionary[this.BIDDING_LIBRARIES[x]][adElementId]){

                return true;
            }
            else if(!adElementId){

                for(var anAdElementId in this.__newBidsDictionary[this.BIDDING_LIBRARIES[x]]){

                    if(this.__newBidsDictionary[this.BIDDING_LIBRARIES[x]][anAdElementId]){

                        return true;
                    }
                }
            }
        }
    }

    return false;
}

//
// Set the placement of the video Ad pre-roll / mid-roll

AdsNinjaAuction.prototype.setVideoPlacement = function(placement){

    this.__videoPlacement                    = placement;
}

AdsNinjaAuction.prototype.getVideoPlacement = function(placement){

    return this.__videoPlacement;
}

AdsNinjaAuction.prototype.logAdUnitEvent = function(adElementId, event, time){

    this.__logData.setExtraAdEventData(adElementId, event, time);
    this.__logData.setAdEventData(adElementId, event, time, 'adServerRequestSentTime', 'auctionStart');
}

//f
// Retruns logData
AdsNinjaAuction.prototype.getLogData = function(){

    return this.__logData.get();
}

//
// Returns true if the auction is only meant to inflate bid pool.
AdsNinjaAuction.prototype.getInflateBidPool = function(){

    return this.__inflateBidPool;
}

//
// Sets value of true if the auction is only meant to inflate bid pool.
AdsNinjaAuction.prototype.setInflateBidPool = function(inflateBidPool){

    this.__inflateBidPool = inflateBidPool;
}

//
// Returns true if the auction is meant to be a no-bidding auction.
AdsNinjaAuction.prototype.getNoBiddingAuction = function(){
    
    return this.__noBiddingAuction;
}

//
// Sets value of true if the auction is meant to be a no-bidding auction.
AdsNinjaAuction.prototype.setNoBiddingAuction = function(noBiddingAuction){
    
    this.__noBiddingAuction = noBiddingAuction;
}

//
// Returns bidders.
AdsNinjaAuction.prototype.getBidders = function(adElementId){
    
    return {
        amazon: this.__amazonBidders[adElementId] || {},
        prebid: this.__prebidBidders[adElementId] || {},
        gam: this.__gamBidders[adElementId] || {},
    };
}

//
// Sets bidders.
AdsNinjaAuction.prototype.setBiddersForAdUnits = function(adUnits){
    
    for(var i = 0; i < adUnits.length; i++){
        
        var adElementId = adUnits[i].code;

        if(!adElementId){

            continue;    
        }

        for(var j = 0; j < adUnits[i].bids.length; j++){

            var bidder = adUnits[i].bids[j].bidder;

            if(!bidder){

                continue;
            }

            if(!this.__prebidBidders.hasOwnProperty(adElementId)){

                this.__prebidBidders[adElementId] = {};
            }

            if(!this.__prebidBidders[adElementId].hasOwnProperty(bidder)){

                this.__prebidBidders[adElementId][bidder] = bidder;
            }
        }

        if(!this.__amazonBidders.hasOwnProperty(adElementId)){

            this.__amazonBidders[adElementId] = {};
        }

        if(!this.__amazonBidders[adElementId].hasOwnProperty('amazon')){

            this.__amazonBidders[adElementId]['amazon'] = 'amazon';
        }

        if(!this.__gamBidders.hasOwnProperty(adElementId)){

            this.__gamBidders[adElementId] = {};
        }

        if(!this.__gamBidders[adElementId].hasOwnProperty('gam')){

            this.__gamBidders[adElementId]['gam'] = 'gam';
        }
    }

    this.__biddersForAdUnits = {};
}

AdsNinjaAuction.prototype.__bidPassedOnlyFromAuctionCheck = function(bid, onlyFromAuctionBidder = []){

    if(!onlyFromAuctionBidder.includes(bid['bidderCode'])){

        return true;
    }

    return bid[this.INDEX_VALNET_BELONG_TO_LAST_AUCTION];
}

window.AdsNinjaAuction = AdsNinjaAuction;
